"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserContext = exports.UserContext = void 0;
var shared_1 = require("@clerk/shared");
Object.defineProperty(exports, "UserContext", { enumerable: true, get: function () { return shared_1.UserContext; } });
Object.defineProperty(exports, "useUserContext", { enumerable: true, get: function () { return shared_1.useUserContext; } });
